import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
  createLatestDealsCompletedClient,
  type CompletedDealsQuery,
  type CompletedDealsResponse,
} from '@y2/api-clients/latest-deals-completed';

const client = createLatestDealsCompletedClient();

export function getLatestDealsCompletedOptions(
  query: CompletedDealsQuery,
  options = {},
): UseQueryOptions<CompletedDealsResponse['data']> {
  return {
    queryKey: ['latest-deals-completed', query],
    queryFn: () => client.get(query).then((res) => res.data.data),
    keepPreviousData: true,
    ...options,
  };
}

export function useLatestDealsCompleted(
  query: CompletedDealsQuery,
  options = {},
) {
  return useQuery(getLatestDealsCompletedOptions(query, options));
}
